<template>
  <!-- OVERLAY -->
  <div class="overlay" @click.self="fechar">
    <!-- MODAL -->
    <div class="modal-container" :class="{ 'modo-rejeicao': modoRejeicao }">
      <!-- HEADER -->
      <div class="modal-header">
        <span class="modal-label">Notícia aberta</span>
        <button class="btn-fechar-modal" @click="fechar" aria-label="Fechar">
          ×
        </button>
      </div>

      <!-- LOADING -->
      <Carregamento v-if="loading" :mensagemCarregamento="'carregando notícia'" />

      <!-- CONTEÚDO -->
      <div v-else-if="noticia" class="modal-body" :class="{ 'body-frozen': modoRejeicao }">
        <!-- TÍTULO + META -->
        <div class="superior">
          <div class="noticia-meta-topo">
            <h1 class="noticia-titulo">{{ noticia.titulo?.toUpperCase() }}</h1>
            <p class="noticia-meta">
              Data de publicação: {{ formatarData(noticia.dataPublicacao) }}
            </p>
            <p class="noticia-meta" v-if="
              noticia.dataAtualizacao &&
              formatarData(noticia.dataAtualizacao) !==
              formatarData(noticia.dataPublicacao)
            ">
              Data de atualização: {{ formatarData(noticia.dataAtualizacao) }}
            </p>
            <p class="noticia-meta">Autor: {{ autorExibido }}</p>
            <p class="noticia-meta" v-if="nomeAcao">
              Ação: {{ nomeAcao }}
            </p>
          </div>

          <!-- TAGS -->
          <div class="noticia-tags" v-if="noticia.palavrasChave?.length">
            <span class="tag" v-for="(palavra, index) in noticia.palavrasChave" :key="index">
              {{ palavra }}
            </span>
          </div>

          <!-- CARD DE INFORMAÇÕES DA ANÁLISE -->
          <div v-if="isAnalisada" class="card-analise" :class="isAceita ? 'analise-status-aceita' : 'analise-status-rejeitada'
            ">
            <div class="analise-topo">
              <div class="analise-badge">
                <i :class="isAceita ? 'ti ti-check' : 'ti ti-x'"></i>
                <span>{{
                  isAceita ? "NOTÍCIA ACEITA" : "NOTÍCIA REJEITADA"
                }}</span>
              </div>
              <span class="analise-data" v-if="noticia.dataAutorizacao">
                <i class="ti ti-calendar-time"></i> Analisada em:
                {{ formatarDataHora(noticia.dataAutorizacao) }}
              </span>
            </div>

            <div class="analise-campos">
              <div class="analise-campo" v-if="noticia.autorizadorNome">
                <span class="campo-rotulo">Avaliador(a):</span>
                <span class="campo-valor">{{ noticia.autorizadorNome }}</span>
              </div>
              <div class="analise-campo" v-if="noticia.abrangenciaNome">
                <span class="campo-rotulo">Abrangência:</span>
                <span class="campo-valor">{{ noticia.abrangenciaNome }}</span>
              </div>
            </div>

            <!-- MOTIVO DA REJEIÇÃO EM DESTAQUE -->
            <div v-if="isRejeitada" class="analise-motivo-box">
              <span class="motivo-titulo">
                <i class="ti ti-notes"></i> Motivo da Rejeição / Parecer da
                Análise:
              </span>
              <p class="motivo-conteudo">
                {{
                  noticia.motivoRejeicao ||
                  "Motivo não informado no momento da rejeição."
                }}
              </p>
            </div>
          </div>

          <!-- INDICADOR DE NOTÍCIA PENDENTE -->
          <div v-else-if="isPendente" class="card-analise analise-status-pendente">
            <div class="analise-topo">
              <div class="analise-badge">
                <i class="ti ti-clock"></i>
                <span>PENDENTE DE ANÁLISE</span>
              </div>
            </div>
          </div>
        </div>

        <!-- LAYOUT DUAS COLUNAS: TEXTO + IMAGEM -->
        <div class="noticia-conteudo-grid">
          <!-- COLUNA ESQUERDA: TEXTO -->
          <div class="noticia-texto-col">
            <div class="noticia-texto" v-html="noticia.texto || noticia.descricao"></div>
          </div>

          <!-- COLUNA DIREITA: IMAGEM -->
          <div class="noticia-imagem-col" v-if="noticia.imagemUrl">
            <img :src="noticia.imagemUrl" :alt="noticia.descricaoImagem" class="noticia-imagem" />
            <div class="noticia-info-extra" v-if="noticia.fonte">
              <p>
                <strong>Fonte:</strong>
                {{
                  noticia.fonte?.length > 0
                    ? noticia.fonte
                    : "Fonte não especificada"
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- NÃO ENCONTRADA -->
      <div v-else class="modal-vazio">
        <p>Notícia não encontrada.</p>
      </div>

      <!-- SEÇÃO DE REJEIÇÃO (aparece sobre o footer quando rejeitar é clicado) -->
      <div v-if="modoRejeicao" class="rejeicao-section">
        <div class="rejeicao-divider-label">Justificar Rejeição</div>
        <div class="rejeicao-body">
          <label class="rejeicao-label">*Diga o motivo da Rejeição</label>
          <textarea v-model="motivoRejeicao" class="rejeicao-textarea" placeholder="" rows="5"></textarea>
          <div class="rejeicao-footer">
            <button class="btn-voltar" @click="cancelarRejeicao" :disabled="processando">
              Voltar
            </button>
            <button class="btn-gravar" @click="confirmarRejeicao" :disabled="processando || !motivoRejeicao.trim()">
              {{ processando ? "Gravando..." : "Gravar" }}
            </button>
          </div>
        </div>
      </div>

      <!-- RODAPÉ COM BOTÕES (visível apenas fora do modo rejeição) -->
      <div class="modal-footer" v-if="noticia && mostrarBotoes && isPendente && !modoRejeicao">
        <button class="btn-rejeitar" @click="iniciarRejeicao" :disabled="processando">
          Rejeitar
        </button>
        <button class="btn-aceitar" @click="aceitar" :disabled="processando">
          {{ processando ? "Processando..." : "Aceitar" }}
        </button>
      </div>


    </div>
  </div>

  <Aviso v-if="avisoView" :texto="mensagemAviso" :sucesso="sucesso" @fecharModal="fecharModalETelaView()" />

  <ModalConfirmarSenha :mostrar="modalSenhaVisivel" :carregando="verificandoSenha" :erro="erroSenha"
    @cancelar="fecharModalSenha" @confirmar="onConfirmarSenha" />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import noticiaService from "@/service/noticiaService";
import usuariosService from "@/service/usuariosService";
import Aviso from "@/components/common/aviso.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import ModalConfirmarSenha from "@/components/usuarios/ModalConfirmarSenha.vue";
import { formatarData, formatarDataHora } from "@/utils/FormatarEntradas";
import { localPublicacaoNoticia } from "@/constants/noticias";

const props = defineProps({
  noticiaId: { type: [String, Number], default: null },
  noticiaObjeto: { type: Object, default: null },
  mostrarBotoes: { type: Boolean, default: true },
});

const emit = defineEmits(["fechar", "aceita", "rejeitada"]);

const route = useRoute();
const router = useRouter();

const loading = ref(false);
const processando = ref(false);
const noticia = ref(null);
const avisoView = ref(false);
const sucesso = ref(false);
const mensagemAviso = ref("");

// Controle do modo rejeição
const modoRejeicao = ref(false);
const motivoRejeicao = ref("");

// Controle do modal de senha
const modalSenhaVisivel = ref(false);
const verificandoSenha = ref(false);
const erroSenha = ref("");
const acaoPendente = ref(""); // "aceitar" ou "rejeitar"

function fecharModalSenha() {
  modalSenhaVisivel.value = false;
  erroSenha.value = "";
}

const resolvedId = computed(() => {
  return (
    props.noticiaId || route.params.noticiaId || route.query.noticiaId || null
  );
});

const statusNormalizado = computed(() => {
  if (!noticia.value) return "";

  const status = String(
    noticia.value.statusDescricao ||
    noticia.value.statusNome ||
    noticia.value.tipoStatus ||
    noticia.value.status ||
    ""
  ).toUpperCase();

  // 1. Se está aguardando autorização (ou autorizado é null/indefinido) -> PENDENTE
  if (
    status.includes("AGUARD") ||
    status.includes("PENDENTE") ||
    noticia.value.autorizado === null
  ) {
    return "PENDENTE";
  }

  // 2. Se status for não autorizada / cancelada / rejeitada -> REJEITADA
  if (
    status.includes("NAO_AUTORIZAD") ||
    status.includes("REJEIT") ||
    status.includes("CANCEL")
  ) {
    return "REJEITADA";
  }

  // 3. Se autorizado for true ou status publicada/agendada -> ACEITA
  if (
    noticia.value.autorizado === true ||
    status.includes("PUBLICAD") ||
    status.includes("AGENDAD") ||
    status.includes("ACEITA")
  ) {
    return "ACEITA";
  }

  // 4. Se autorizado for false e não for pendente -> REJEITADA
  if (noticia.value.autorizado === false) {
    return "REJEITADA";
  }

  return "PENDENTE";
});

const isPendente = computed(() => statusNormalizado.value === "PENDENTE");

// Autor exibido na identificação: quem publicou (autorPublicacaoNome) ou,
// na falta dele, o autor da notícia (autorNome). Ambos vêm de RegistroNoticiaResponse.
const autorExibido = computed(() => {
  const autor =
    noticia.value?.autorPublicacaoNome || noticia.value?.autorNome || "";
  return String(autor).trim() || "Não informado";
});
// Nome da ação que publicou. O swagger documenta `acao` como string, mas
// outras telas tratam a resposta como objeto ({ id, titulo }); cobre os dois.
const nomeAcao = computed(() => {
  const acao = noticia.value?.acao;
  if (!acao) return "";
  if (typeof acao === "string") return acao.trim();
  return String(acao.titulo || acao.nome || "").trim();
});
const localPublicacao = computed(() => localPublicacaoNoticia(noticia.value));
const isAceita = computed(() => statusNormalizado.value === "ACEITA");
const isRejeitada = computed(() => statusNormalizado.value === "REJEITADA");
const isAnalisada = computed(() => isAceita.value || isRejeitada.value);

function fechar() {
  emit("fechar");
  if (route.name === "noticia-prex-view") {
    router.back();
  }
}

async function fecharModalETelaView() {
  if (sucesso.value == false) {
    avisoView.value = false;
    return;
  }
  avisoView.value = false;
  await new Promise((resolve) => setTimeout(resolve, 300));
  fechar();
}

// Inicia o modo de rejeição (mostra o campo de motivo)
function iniciarRejeicao() {
  motivoRejeicao.value = "";
  modoRejeicao.value = true;
}

// Cancela e volta para o estado normal
function cancelarRejeicao() {
  modoRejeicao.value = false;
  motivoRejeicao.value = "";
}

// Confirma a rejeição com motivo
function confirmarRejeicao() {
  if (!noticia.value?.id || !motivoRejeicao.value.trim()) return;
  acaoPendente.value = "rejeitar";
  modalSenhaVisivel.value = true;
}

// Aceita a notícia
function aceitar() {
  if (!noticia.value?.id) return;
  acaoPendente.value = "aceitar";
  modalSenhaVisivel.value = true;
}

async function onConfirmarSenha(senha) {
  verificandoSenha.value = true;
  erroSenha.value = "";
  try {
    const valida = await usuariosService.verificarSenha(senha);
    if (!valida) {
      erroSenha.value = "Senha do SIGAA incorreta. Tente novamente.";
      return;
    }
    fecharModalSenha();
    if (acaoPendente.value === "aceitar") {
      await executarAceitacao();
    } else if (acaoPendente.value === "rejeitar") {
      await executarRejeicao();
    }
  } catch (error) {
    erroSenha.value = "Erro ao validar senha do SIGAA.";
  } finally {
    verificandoSenha.value = false;
  }
}

async function executarAceitacao() {
  processando.value = true;
  try {
    await noticiaService.autorizarNoticia(noticia.value.id, true);
    emit("aceita", noticia.value);
    sucesso.value = true;
    mensagemAviso.value = "Notícia autorizada com sucesso!";
    avisoView.value = true;
  } catch (error) {
    sucesso.value = false;
    mensagemAviso.value = "Erro ao aceitar notícia!";
    avisoView.value = true;
    console.error("Erro ao aceitar notícia:", error);
  } finally {
    processando.value = false;
  }
}

async function executarRejeicao() {
  processando.value = true;
  try {
    await noticiaService.autorizarNoticia(
      noticia.value.id,
      false,
      motivoRejeicao.value.trim()
    );

    emit("rejeitada", noticia.value);
    sucesso.value = true;
    mensagemAviso.value = "Notícia rejeitada com sucesso!";
    avisoView.value = true;
    modoRejeicao.value = false;
  } catch (error) {
    console.error("Erro ao rejeitar notícia:", error);
    sucesso.value = false;
    mensagemAviso.value = "Erro ao rejeitar notícia!";
    avisoView.value = true;
  } finally {
    processando.value = false;
  }
}

async function carregarNoticia() {
  if (props.noticiaObjeto) {
    noticia.value = { ...props.noticiaObjeto };
  }
  const idParaBuscar = resolvedId.value || props.noticiaObjeto?.id;
  if (!idParaBuscar) return;

  if (!noticia.value) {
    loading.value = true;
  }
  try {
    const response = await noticiaService.getNoticiaById(idParaBuscar);
    noticia.value = { ...(noticia.value || {}), ...response };
  } catch (error) {
    console.error("Erro ao carregar notícia:", error);
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await carregarNoticia();
});
</script>

<style scoped>
/* CONTAINER DO MODAL */
.modal-container {
  border-radius: 12px;
  width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}



.modal-header-titulo {
  color: var(--branco);
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.btn-fechar {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: var(--branco);
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1;
  transition: background-color 0.2s ease;
}

.btn-fechar:hover {
  background: hsla(0, 0%, 100%, 0.15);
}

/* BODY */
.superior {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.modal-body {
  background: var(--branco);
  padding: 1rem 2rem;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;

}

/* Quando em modo rejeição, o body fica com altura reduzida (efeito "congelado") */
.modal-body.body-frozen {
  flex: 0 0 auto;
  max-height: 260px;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
  opacity: 0.85;
}

/* META TOPO */
.noticia-meta-topo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.noticia-titulo {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--roxo-escuro);
  line-height: 1.3;
  margin: 0 0 6px 0;
  text-transform: uppercase;
}

.noticia-meta {
  font-size: 0.8rem;
  color: var(--cinza-escuro);
  margin: 0;
}

/* TAGS */
.noticia-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  padding: 4px 12px;
  border: 1px solid var(--cinza-escuro);
  border-radius: 4px;
  font-size: 0.78rem;
  color: var(--cinza-escuro);
  background: transparent;
}

/* GRID DUAS COLUNAS */
.noticia-conteudo-grid {
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
}

/* TEXTO */
.noticia-texto-col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.noticia-texto {
  font-size: 0.83rem;
  color: var(--cinza-escuro);
  line-height: 1.65;
}

.noticia-texto :deep(p) {
  margin-bottom: 10px;
}

.noticia-texto :deep(strong) {
  font-weight: 700;
  color: var(--roxo-escuro);
}

/* IMAGEM */
.noticia-imagem-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.noticia-imagem {
  width: 300px;
  border-radius: 6px;
  object-fit: cover;
  max-height: 220px;
}

.noticia-info-extra {
  font-size: 0.78rem;
  color: var(--cinza-escuro);
  line-height: 1.5;
}

.noticia-info-extra p {
  margin: 0 0 4px 0;
}

/* FOOTER */
.modal-footer {
  padding: 14px 24px;
  display: flex;
  justify-content: end;
  gap: 16px;
  border-top: 1px solid var(--cinza-claro);
  flex-shrink: 0;
  background: var(--branco);
}

.btn-rejeitar,
.btn-aceitar {
  padding: 9px 36px;
  border-radius: 5px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition:
    opacity 0.2s ease,
    transform 0.1s ease,
    background-color 0.2s ease,
    filter 0.2s ease;
  min-width: 110px;
}

.btn-rejeitar {
  background: var(--vermelho-escuro);
  color: var(--branco);
}

.btn-aceitar {
  background: var(--verde-escuro);
  color: var(--branco);
}

/* Hover */
.btn-rejeitar:hover:not(:disabled) {
  background: var(--vermelho);
}

.btn-aceitar:hover:not(:disabled) {
  background: var(--verde);

}

/* Desabilitado */
.btn-rejeitar:disabled,
.btn-aceitar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Clique */
.btn-rejeitar:active:not(:disabled),
.btn-aceitar:active:not(:disabled) {
  transform: scale(0.97);
}

/* ================================
   SEÇÃO DE REJEIÇÃO
   ================================ */
.rejeicao-section {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: var(--branco);
}

/* Faixa com label "Justificar Rejeição" */
.rejeicao-divider-label {
  background: var(--roxo-superficie);
  color: var(--roxo-primario);
  font-size: 0.82rem;
  font-weight: 700;
  text-align: center;
  padding: 8px 24px;
  letter-spacing: 0.04em;
  border-top: 1px solid var(--roxo-superficie);
  border-bottom: 1px solid var(--roxo-superficie);
}

/* Corpo da rejeição */
.rejeicao-body {
  padding: 20px 24px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rejeicao-label {
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--roxo-escuro);
}

.rejeicao-textarea {
  width: 100%;
  min-height: 120px;
  border: 1.5px solid var(--roxo-claro);
  border-radius: 5px;
  padding: 10px 12px;
  font-size: 0.85rem;
  color: var(--cinza-escuro);
  resize: vertical;
  outline: none;
  font-family: inherit;
  line-height: 1.5;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.rejeicao-textarea:focus {
  border-color: var(--roxo-primario);
  box-shadow: 0 0 0 3px hsla(258, 53%, 28%, 0.08);
}

/* Botões da rejeição */
.rejeicao-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 4px;
}

.btn-voltar,
.btn-gravar {
  padding: 9px 36px;
  border-radius: 5px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition:
    opacity 0.2s ease,
    transform 0.1s ease;
  min-width: 110px;
}

.btn-voltar {
  background: var(--cinza-claro);
  color: var(--cinza-escuro);
}

.btn-voltar:hover:not(:disabled) {
  background: var(--cinza-claro);
}

.btn-gravar {
  background: var(--roxo-primario);
  color: var(--branco);
}

.btn-gravar:hover:not(:disabled) {
  background: var(--roxo-primario);
}

.btn-voltar:disabled,
.btn-gravar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-voltar:active:not(:disabled),
.btn-gravar:active:not(:disabled) {
  transform: scale(0.97);
}

/* CARD DE ANÁLISE / STATUS */
.card-analise {
  padding: 8px;
  width: fit-content;
  height: min-content;
  border-radius: 12px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-analise.analise-status-aceita {
  background-color: var(--verde-claro);
  border-color: var(--verde-claro);
}

.card-analise.analise-status-rejeitada {
  background-color: var(--vermelho-claro);
  border-color: var(--vermelho-claro);
}

.card-analise.analise-status-pendente {
  background-color: var(--laranja-claro);
  border-color: var(--laranja-claro);
}

.analise-topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.analise-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.analise-status-aceita .analise-badge {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
}

.analise-status-rejeitada .analise-badge {
  background-color: var(--vermelho-claro);
  color: var(--vermelho-escuro);
}

.analise-status-pendente .analise-badge {
  background-color: var(--laranja-claro);
  color: var(--laranja-escuro);
}

.analise-data {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--cinza-medio);
}

.analise-campos {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 4px;
}

.analise-campo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.campo-rotulo {
  font-weight: 600;
  color: var(--cinza-escuro);
}

.campo-valor {
  font-weight: 500;
  color: var(--cinza-escuro);
}

.analise-motivo-box {
  margin-top: 4px;
  padding: 12px;
  border-radius: 6px;
  background-color: var(--vermelho-claro);
  border: 1px solid var(--vermelho-claro);
}

.motivo-titulo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--vermelho-escuro);
  margin-bottom: 6px;
  text-transform: uppercase;
}

.motivo-conteudo {
  font-size: 14px;
  line-height: 1.5;
  color: var(--cinza-escuro);
  white-space: pre-line;
  margin: 0;
}

.modal-footer-analisada {
  justify-content: flex-end;
}


/* LOADING / VAZIO */
.modal-loading,
.modal-vazio {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--cinza-medio);
  font-size: 0.95rem;
}

/* RESPONSIVO */
@media (max-width: 600px) {
  .modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .superior {
    flex-direction: column;
    gap: 1rem;
  }

  .card-analise {
    width: 100%;
  }

  .noticia-meta-topo {
    width: 100%;
  }

  .modal-container {
    width: 95%;
    max-height: 95vh;
    border-radius: 12px 12px 0 0;
  }

  .noticia-conteudo-grid {
    flex-direction: column;
  }

  .noticia-imagem-col {
    order: -1;
  }

  .noticia-titulo {
    font-size: 1rem;
  }

  .modal-footer,
  .rejeicao-footer {
    padding: 12px 16px;
  }

  .btn-rejeitar,
  .btn-aceitar,
  .btn-voltar,
  .btn-gravar {
    flex: 1;
  }
}
</style>
